angular.module('lf.desktop')

.directive('redeemInputGroup', function () {
  return {
    restrict: 'A',
    link: function (scope, el, attrs) {
      var $inputs = el.find('input[type=text]');

      el.on('input', 'input[type=text]', function (e) {
        var $input = $(e.target);
        var index = $inputs.index($input);
        var $stateBtn = el.closest('form').find('select[name=redeemState]');

        if ($input.val().length === 4) {
          if (index + 1 < $inputs.length) {
            setTimeout(function(){
              $inputs[index + 1].focus();
            }, 0);
          } else {
            setTimeout(function(){
              $input.blur();
              $stateBtn.focus();
            }, 0);
          }
        } else if ($input.val().length > 4) {
          var pastedStr = $input.val();
          // trim the whitespaces
          pastedStr = pastedStr.trim();
          // remove all the dashes, if there are any 
          pastedStr = pastedStr.replace(/-/g, "");
          do {
            $input = $inputs.eq(index++);
            scope.redeemCodes[$input.attr('name')] = pastedStr.substring(0, 4);

            pastedStr = pastedStr.substring(4);
          } while ((pastedStr.length > 0) && (index < $inputs.length));

          scope.$apply();

          $stateBtn.focus();
        }
      });
    }
  };
});
